import { appIntl } from 'utility/context/IntlGlobalProvider';
import moment from 'moment';

export const getContactStatusLabel = (contactStatus, suspensionStopDate) => {
  const intl = appIntl();
  let contactStatusLabel = '';
  let contactStatusLabelInfo = '';

  const formattedDate = suspensionStopDate ? moment(suspensionStopDate).format('YYYY-MM-DD') : '-';

  switch (contactStatus) {
    case 0:
      contactStatusLabel = intl.formatMessage({ id: 'contacts.status.0' });
      contactStatusLabelInfo = intl.formatMessage({ id: 'contacts.status.0' });
      break;
    case 1:
      contactStatusLabel = intl.formatMessage({ id: 'contacts.status.1' });
      contactStatusLabelInfo = intl.formatMessage({ id: 'contacts.status.1' });
      break;
    case 2:
    case 3:
      contactStatusLabel = intl.formatMessage({ id: `contacts.status.${contactStatus}` });
      contactStatusLabelInfo = intl.formatMessage(
        { id: `contacts.statusTooltip.${contactStatus}` },
        { date: formattedDate }
      );
      break;
    default:
      contactStatusLabel = intl.formatMessage({ id: 'contacts.status.unknown' });
      contactStatusLabelInfo = intl.formatMessage({ id: 'contacts.status.unknown' });
      break;
  }

  return { contactStatusLabel, contactStatusLabelInfo };
};
